export class NomenclatureAccountResponse {
	balance: number;
	budget: number;
	children: NomenclatureAccountResponse[];
	displayId: string;
	id: number;
	level: number;
	month: number;
	name: string;
	parentId: number;
	year: number;
	//for frontend
	show!: boolean;
	temporal!: boolean;
	deleting!: boolean;
	creating!: boolean;
	editing!: boolean;
}

export class NomenclatureAccountRequest {
	balance: string;
	displayId: string;
	name: string;
	parentId: number;
}